import Vue from 'vue';
import Router from 'vue-router';
import { interopDefault } from './utils';

const _9000170c = () => interopDefault(import('../pages/monitoring.vue'
/* webpackChunkName: "pages/monitoring" */
));

const _3a852e3e = () => interopDefault(import('../pages/redirect_url.vue'
/* webpackChunkName: "pages/redirect_url" */
));

const _02c3aa2c = () => interopDefault(import('../pages/tools/grid.vue'
/* webpackChunkName: "pages/tools/grid" */
));

const _29ec0d04 = () => interopDefault(import('../pages/_market/_language/index.vue'
/* webpackChunkName: "pages/_market/_language/index" */
));

const _3844c03e = () => interopDefault(import('../pages/_market/_language/cart/index.vue'
/* webpackChunkName: "pages/_market/_language/cart/index" */
));

const _f4fc027c = () => interopDefault(import('../pages/_market/_language/help/index.vue'
/* webpackChunkName: "pages/_market/_language/help/index" */
));

const _abb71344 = () => interopDefault(import('../pages/_market/_language/login/index.vue'
/* webpackChunkName: "pages/_market/_language/login/index" */
));

const _3b8cde59 = () => interopDefault(import('../pages/_market/_language/lost-password/index.vue'
/* webpackChunkName: "pages/_market/_language/lost-password/index" */
));

const _5890c35a = () => interopDefault(import('../pages/_market/_language/reset-password/index.vue'
/* webpackChunkName: "pages/_market/_language/reset-password/index" */
));

const _539ea34e = () => interopDefault(import('../pages/_market/_language/signup/index.vue'
/* webpackChunkName: "pages/_market/_language/signup/index" */
));

const _1580b3ac = () => interopDefault(import('../pages/_market/_language/sitemap/index.vue'
/* webpackChunkName: "pages/_market/_language/sitemap/index" */
));

const _0d2f775f = () => interopDefault(import('../pages/_market/_language/store-locator/index.vue'
/* webpackChunkName: "pages/_market/_language/store-locator/index" */
));

const _06451268 = () => interopDefault(import('../pages/_market/_language/user/index.vue'
/* webpackChunkName: "pages/_market/_language/user/index" */
));

const _30655fb0 = () => interopDefault(import('../pages/_market/_language/help/confirm.vue'
/* webpackChunkName: "pages/_market/_language/help/confirm" */
));

const _265cd31c = () => interopDefault(import('../pages/_market/_language/help/deliveryConfirm.vue'
/* webpackChunkName: "pages/_market/_language/help/deliveryConfirm" */
));

const _2483fd6f = () => interopDefault(import('../pages/_market/_language/poc/grid.vue'
/* webpackChunkName: "pages/_market/_language/poc/grid" */
));

const _a5b3aea6 = () => interopDefault(import('../pages/_market/_language/s/catalogue-luminaires.vue'
/* webpackChunkName: "pages/_market/_language/s/catalogue-luminaires" */
));

const _524c3f8c = () => interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
/* webpackChunkName: "pages/_market/_language/s/home-by-me" */
));

const _3a23f966 = () => interopDefault(import('../pages/_market/_language/s/lighting.vue'
/* webpackChunkName: "pages/_market/_language/s/lighting" */
));

const _9a2d2efe = () => interopDefault(import('../pages/_market/_language/s/sustainable-development.vue'
/* webpackChunkName: "pages/_market/_language/s/sustainable-development" */
));

const _6bf56736 = () => interopDefault(import('../pages/_market/_language/t/confirmed.vue'
/* webpackChunkName: "pages/_market/_language/t/confirmed" */
));

const _2ee03026 = () => interopDefault(import('../pages/_market/_language/t/delivery.vue'
/* webpackChunkName: "pages/_market/_language/t/delivery" */
));

const _38a035c0 = () => interopDefault(import('../pages/_market/_language/t/login.vue'
/* webpackChunkName: "pages/_market/_language/t/login" */
));

const _4c4f80fb = () => interopDefault(import('../pages/_market/_language/t/lost-password.vue'
/* webpackChunkName: "pages/_market/_language/t/lost-password" */
));

const _262ece1d = () => interopDefault(import('../pages/_market/_language/t/payment.vue'
/* webpackChunkName: "pages/_market/_language/t/payment" */
));

const _2001a4c6 = () => interopDefault(import('../pages/_market/_language/t/payment-paypal-pending.vue'
/* webpackChunkName: "pages/_market/_language/t/payment-paypal-pending" */
));

const _336d49e7 = () => interopDefault(import('../pages/_market/_language/t/refused.vue'
/* webpackChunkName: "pages/_market/_language/t/refused" */
));

const _27c06f51 = () => interopDefault(import('../pages/_market/_language/t/signup.vue'
/* webpackChunkName: "pages/_market/_language/t/signup" */
));

const _ca2c4e08 = () => interopDefault(import('../pages/_market/_language/user/gift-cards.vue'
/* webpackChunkName: "pages/_market/_language/user/gift-cards" */
));

const _7173edc4 = () => interopDefault(import('../pages/_market/_language/user/orders/index.vue'
/* webpackChunkName: "pages/_market/_language/user/orders/index" */
));

const _34d303a3 = () => interopDefault(import('../pages/_market/_language/user/profile.vue'
/* webpackChunkName: "pages/_market/_language/user/profile" */
));

const _7fa903e6 = () => interopDefault(import('../pages/_market/_language/user/profile/index.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/index" */
));

const _b3795e94 = () => interopDefault(import('../pages/_market/_language/user/profile/addresses.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/addresses" */
));

const _81e5009a = () => interopDefault(import('../pages/_market/_language/user/profile/alerts.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/alerts" */
));

const _289a7984 = () => interopDefault(import('../pages/_market/_language/user/profile/FormAddress.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/FormAddress" */
));

const _068084b7 = () => interopDefault(import('../pages/_market/_language/user/profile/password.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/password" */
));

const _0d9bb63b = () => interopDefault(import('../pages/_market/_language/user/wishlist.vue'
/* webpackChunkName: "pages/_market/_language/user/wishlist" */
));

const _7bd80916 = () => interopDefault(import('../pages/_market/_language/configurator/product/_model.vue'
/* webpackChunkName: "pages/_market/_language/configurator/product/_model" */
));

const _2a295f77 = () => interopDefault(import('../pages/_market/_language/e/magazine/_slug.vue'
/* webpackChunkName: "pages/_market/_language/e/magazine/_slug" */
));

const _495b33e4 = () => interopDefault(import('../pages/_market/_language/help/contact/_form.vue'
/* webpackChunkName: "pages/_market/_language/help/contact/_form" */
));

const _36aa69d4 = () => interopDefault(import('../pages/_market/_language/help/faq/_answer.vue'
/* webpackChunkName: "pages/_market/_language/help/faq/_answer" */
));

const _13164544 = () => interopDefault(import('../pages/_market/_language/help/return/_form.vue'
/* webpackChunkName: "pages/_market/_language/help/return/_form" */
));

const _5c0f5fa0 = () => interopDefault(import('../pages/_market/_language/user/orders/_reference.vue'
/* webpackChunkName: "pages/_market/_language/user/orders/_reference" */
));

const _6bf7908a = () => interopDefault(import('../pages/_market/_language/c/_alias.vue'
/* webpackChunkName: "pages/_market/_language/c/_alias" */
));

const _282893f6 = () => interopDefault(import('../pages/_market/_language/configurator/_model.vue'
/* webpackChunkName: "pages/_market/_language/configurator/_model" */
));

const _61c0b102 = () => interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
/* webpackChunkName: "pages/_market/_language/inspirations/_slug" */
));

const _2e099d8e = () => interopDefault(import('../pages/_market/_language/p/_alias.vue'
/* webpackChunkName: "pages/_market/_language/p/_alias" */
));

const _b0522e74 = () => interopDefault(import('../pages/_market/_language/q/_keyword.vue'
/* webpackChunkName: "pages/_market/_language/q/_keyword" */
));

const _25b42e18 = () => interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
/* webpackChunkName: "pages/_market/_language/e/_alias/_slug" */
));

const _d3e9a946 = () => interopDefault(import('../pages/_market/_language/index.vue'
/* webpackChunkName: "" */
));

const _63bd6b49 = () => interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
/* webpackChunkName: "" */
));

const _52a6eaad = () => interopDefault(import('../pages/_market/_language/s/lighting.vue'
/* webpackChunkName: "" */
));

const _4b34c87e = () => interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
/* webpackChunkName: "" */
));

const _3cb0debb = () => interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
/* webpackChunkName: "" */
));

const _4aca05f8 = () => interopDefault(import('../pages/_market/_language/store-locator/index.vue'
/* webpackChunkName: "" */
));

Vue.use(Router);

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'; // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.

    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto';
    }); // Setting scrollRestoration to manual again when returning to this page.

    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual';
    });
  }
}

const scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false; // if no children detected and scrollToTop is not explicitly disabled

  if (to.matched.length < 2 && to.matched.every(r => r.components.default.options.scrollToTop !== false)) {
    // scroll to the top of the page
    position = {
      x: 0,
      y: 0
    };
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = {
      x: 0,
      y: 0
    };
  } // savedPosition is only available for popstate navigations (back button)


  if (savedPosition) {
    position = savedPosition;
  }

  return new Promise(resolve => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash; // CSS.escape() is not supported with IE and Edge.

        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1));
        }

        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = {
              selector: hash
            };
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).');
        }
      }

      resolve(position);
    });
  });
};

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,
    routes: [{
      path: "/monitoring",
      component: _9000170c,
      name: "monitoring"
    }, {
      path: "/redirect_url",
      component: _3a852e3e,
      name: "redirect_url"
    }, {
      path: "/tools/grid",
      component: _02c3aa2c,
      name: "tools-grid"
    }, {
      path: "/:market/:language",
      component: _29ec0d04,
      name: "market-language"
    }, {
      path: "/:market/:language/cart",
      component: _3844c03e,
      name: "market-language-cart"
    }, {
      path: "/:market/:language/help",
      component: _f4fc027c,
      name: "market-language-help"
    }, {
      path: "/:market/:language/login",
      component: _abb71344,
      name: "market-language-login"
    }, {
      path: "/:market/:language/lost-password",
      component: _3b8cde59,
      name: "market-language-lost-password"
    }, {
      path: "/:market/:language/reset-password",
      component: _5890c35a,
      name: "market-language-reset-password"
    }, {
      path: "/:market/:language/signup",
      component: _539ea34e,
      name: "market-language-signup"
    }, {
      path: "/:market/:language/sitemap",
      component: _1580b3ac,
      name: "market-language-sitemap"
    }, {
      path: "/:market/:language/store-locator",
      component: _0d2f775f,
      name: "market-language-store-locator"
    }, {
      path: "/:market/:language/user",
      component: _06451268,
      name: "market-language-user"
    }, {
      path: "/:market/:language/help/confirm",
      component: _30655fb0,
      name: "market-language-help-confirm"
    }, {
      path: "/:market/:language/help/deliveryConfirm",
      component: _265cd31c,
      name: "market-language-help-deliveryConfirm"
    }, {
      path: "/:market/:language/poc/grid",
      component: _2483fd6f,
      name: "market-language-poc-grid"
    }, {
      path: "/:market/:language/s/catalogue-luminaires",
      component: _a5b3aea6,
      name: "market-language-s-catalogue-luminaires"
    }, {
      path: "/:market/:language/s/home-by-me",
      component: _524c3f8c,
      name: "market-language-s-home-by-me"
    }, {
      path: "/:market/:language/s/lighting",
      component: _3a23f966,
      name: "market-language-s-lighting"
    }, {
      path: "/:market/:language/s/sustainable-development",
      component: _9a2d2efe,
      name: "market-language-s-sustainable-development"
    }, {
      path: "/:market/:language/t/confirmed",
      component: _6bf56736,
      name: "market-language-t-confirmed"
    }, {
      path: "/:market/:language/t/delivery",
      component: _2ee03026,
      name: "market-language-t-delivery"
    }, {
      path: "/:market/:language/t/login",
      component: _38a035c0,
      name: "market-language-t-login"
    }, {
      path: "/:market/:language/t/lost-password",
      component: _4c4f80fb,
      name: "market-language-t-lost-password"
    }, {
      path: "/:market/:language/t/payment",
      component: _262ece1d,
      name: "market-language-t-payment"
    }, {
      path: "/:market/:language/t/payment-paypal-pending",
      component: _2001a4c6,
      name: "market-language-t-payment-paypal-pending"
    }, {
      path: "/:market/:language/t/refused",
      component: _336d49e7,
      name: "market-language-t-refused"
    }, {
      path: "/:market/:language/t/signup",
      component: _27c06f51,
      name: "market-language-t-signup"
    }, {
      path: "/:market/:language/user/gift-cards",
      component: _ca2c4e08,
      name: "market-language-user-gift-cards"
    }, {
      path: "/:market/:language/user/orders",
      component: _7173edc4,
      name: "market-language-user-orders"
    }, {
      path: "/:market/:language/user/profile",
      component: _34d303a3,
      children: [{
        path: "",
        component: _7fa903e6,
        name: "market-language-user-profile"
      }, {
        path: "addresses",
        component: _b3795e94,
        name: "market-language-user-profile-addresses"
      }, {
        path: "alerts",
        component: _81e5009a,
        name: "market-language-user-profile-alerts"
      }, {
        path: "FormAddress",
        component: _289a7984,
        name: "market-language-user-profile-FormAddress"
      }, {
        path: "password",
        component: _068084b7,
        name: "market-language-user-profile-password"
      }]
    }, {
      path: "/:market/:language/user/wishlist",
      component: _0d9bb63b,
      name: "market-language-user-wishlist"
    }, {
      path: "/:market/:language/configurator/product/:model?",
      component: _7bd80916,
      name: "market-language-configurator-product-model"
    }, {
      path: "/:market/:language/e/magazine/:slug?",
      component: _2a295f77,
      name: "market-language-e-magazine-slug"
    }, {
      path: "/:market/:language/help/contact/:form?",
      component: _495b33e4,
      name: "market-language-help-contact-form"
    }, {
      path: "/:market/:language/help/faq/:answer?",
      component: _36aa69d4,
      name: "market-language-help-faq-answer"
    }, {
      path: "/:market/:language/help/return/:form?",
      component: _13164544,
      name: "market-language-help-return-form"
    }, {
      path: "/:market/:language/user/orders/:reference?",
      component: _5c0f5fa0,
      name: "market-language-user-orders-reference"
    }, {
      path: "/:market/:language/c/:alias?",
      component: _6bf7908a,
      name: "market-language-c-alias"
    }, {
      path: "/:market/:language/configurator/:model?",
      component: _282893f6,
      name: "market-language-configurator-model"
    }, {
      path: "/:market/:language/inspirations/:slug?",
      component: _61c0b102,
      name: "market-language-inspirations-slug"
    }, {
      path: "/:market/:language/p/:alias?",
      component: _2e099d8e,
      name: "market-language-p-alias"
    }, {
      path: "/:market/:language/q/:keyword?",
      component: _b0522e74,
      name: "market-language-q-keyword"
    }, {
      path: "/:market/:language/e/:alias?/:slug?",
      component: _25b42e18,
      name: "market-language-e-alias-slug"
    }, {
      path: "/",
      component: _d3e9a946,
      name: "market-language-home-fr"
    }, {
      path: "/:market/:language/inspirations*",
      component: _63bd6b49,
      name: "market-language-inspirations-fr"
    }, {
      path: "/:market/:language/inspirationen*",
      component: _63bd6b49,
      name: "market-language-inspirations-de"
    }, {
      path: "/:market/:language/ispirazione*",
      component: _63bd6b49,
      name: "market-language-inspirations-it"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-en"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-pt"
    }, {
      path: "/:market/:language/inspiracion*",
      component: _63bd6b49,
      name: "market-language-inspirations-es"
    }, {
      path: "/:market/:language/s/inspiratie*",
      component: _63bd6b49,
      name: "market-language-inspirations-nl"
    }, {
      path: "/:market/:language/s/luminaires*",
      component: _52a6eaad,
      name: "market-language-lighting-fr"
    }, {
      path: "/:market/:language/s/leuchten*",
      component: _52a6eaad,
      name: "market-language-lighting-de"
    }, {
      path: "/:market/:language/s/illuminazioni*",
      component: _52a6eaad,
      name: "market-language-lighting-it"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-en"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-pt"
    }, {
      path: "/:market/:language/s/lamparas*",
      component: _52a6eaad,
      name: "market-language-lighting-es"
    }, {
      path: "/:market/:language/s/verlichting*",
      component: _52a6eaad,
      name: "market-language-lighting-nl"
    }, {
      path: "/:market/:language/s/atelier-deco*",
      component: _4b34c87e,
      name: "market-language-home-by-me-fr"
    }, {
      path: "/:market/:language/s/atelier-arredo*",
      component: _4b34c87e,
      name: "market-language-home-by-me-it"
    }, {
      path: "/:market/:language/s/taller-de-decoracion*",
      component: _4b34c87e,
      name: "market-language-home-by-me-es"
    }, {
      path: "/:market/:language/s/dekowerkstatt*",
      component: _4b34c87e,
      name: "market-language-home-by-me-de"
    }, {
      path: "/:market/:language/s/decor-workshop*",
      component: _4b34c87e,
      name: "market-language-home-by-me-en"
    }, {
      path: "/:market/:language/:alias/:slug",
      component: _3cb0debb,
      name: "market-language-editorial"
    }, {
      path: "/:market/:language/magasins/",
      component: _4aca05f8,
      name: "store-locator"
    }],
    fallback: false
  });
}